import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/primeng';
import { InputOptionComponent } from './input-option.component';
import { InputOptionService } from './input-option.service';
@NgModule({
  imports: [
    CommonModule, FormsModule, AutoCompleteModule
  ],
  declarations: [InputOptionComponent],
  exports: [InputOptionComponent],
  providers: [InputOptionService]
})
export class InputOptionModule { }



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/user/input-option/input-option.module.ts